export const getImageSize = (sceneSrc: string): Promise<{ width: number; height: number }> =>
  new Promise(resolve => {
    const element = new Image();
    element.src = sceneSrc;
    element.onload = () => {
      resolve({ width: element.naturalWidth, height: element.naturalHeight });
    };
  });

export const getVideoSize = (sceneSrc: string): Promise<{ width: number; height: number }> =>
  new Promise(resolve => {
    const element = document.createElement('video');
    element.preload = 'auto';
    element.src = sceneSrc;
    element.onloadeddata = () => {
      resolve({ width: element.videoWidth, height: element.videoHeight });
    };
  });
